import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';
import { TenantSettingsComponent } from './tenant-settings.component';

const routes: Routes = [
  {
    path: '',
    component: TenantSettingsComponent,
    title: 'Settings'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantSettingsRoutingModule { }
